import {
  ModuleWithProviders,
  NgModule,
  Optional,
  SkipSelf,
  Type,
} from '@angular/core';
import { ApiModule as SystemManagementApiModule } from './system-management-api';

function apiConfigurationFactory<T>(type: Type<T>, url: string): () => T {
  return () =>
    new type({
      basePath: url,
    });
}

@NgModule({
  declarations: [],
  imports: [SystemManagementApiModule],
  exports: [SystemManagementApiModule],
})
export class SIGVCoreApiModule {
  constructor(@Optional() @SkipSelf() parentModule: SIGVCoreApiModule) {
    if (parentModule) {
      throw new Error(
        `${
          new.target.name
        } is already loaded. Import in your base AppModule only.`
      );
    }
  }

  // static forRoot(config: ApiUrlConfig): ModuleWithProviders<SIGVCoreApiModule> {
  //   return {
  //     ngModule: SIGVCoreApiModule,
  //     providers: [
  //       ...(SystemManagementApiModule.forRoot(apiConfigurationFactory<SystemManagementApiConfiguration>(SystemManagementApiConfiguration, config['systemManagement'])).providers ?? [])
  //     ]
  //   };
  // }
  public static forRoot(
    apiConfig: any
  ): ModuleWithProviders<SIGVCoreApiModule> {
    let apiUrlConfig: any;
    apiUrlConfig = apiConfig;
    return {
      ngModule: SIGVCoreApiModule,
      providers: [],
    };
  }
}
